import { Flex, Popover, Text } from "@/atoms"
import { Image } from "@/icons"

import styles from "../TakenActions.module.scss"

type Props = {
  reference: string
  // Renders as an external link (pr / jira) vs muted text (runtime env / ci image).
  isLink: boolean
  link?: string
  extraCount?: number
  extraReferences?: string[]
}

export const ActionReference = ({
  reference,
  isLink,
  link,
  extraCount,
  extraReferences
}: Props) => (
  <>
    <span className={styles.rowDivider} />
    {isLink ? (
      <a
        className={styles.rowRefLink}
        href={link}
        target="_blank"
        rel="noreferrer"
      >
        {reference}
      </a>
    ) : (
      <Text className={styles.rowRef}>
        {reference}
        {!!extraCount && !extraReferences?.length && ` +${extraCount}`}
        {!!extraCount && !!extraReferences?.length && (
          <Popover
            destroyOnHidden
            trigger={["hover", "focus"]}
            content={
              <Flex vertical gap={8}>
                {extraReferences.map((name) => (
                  <Flex key={name} align="center" gap={8}>
                    <Image className={styles.rowIcon} />
                    <Text>{name}</Text>
                  </Flex>
                ))}
              </Flex>
            }
          >
            <button type="button" className={styles.rowRefExtra}>
              {` +${extraCount}`}
            </button>
          </Popover>
        )}
      </Text>
    )}
  </>
)
